<template>
  <import-csv v-model="showImport" type="products" :fields="importFields" importAction="productsImport" :instructions="instructions" ref="import" @refresh="$emit('refresh')"/>
</template>

<script>
export default {
  name: 'InventoryProductsImport',
  props: {
    value: {type:Boolean,required:true}
  },
  data() {
    return {
      showImport: this.value,
      importFields: [{name:'Name',mapTo:'',mandatory:true},{name:'SKU',mapTo:'',mandatory:false},
                     {name:'Spirit',mapTo:'',mandatory:true},{name:'Strength',mapTo:'',mandatory:true},
                     {name:'Bottle size',mapTo:'',mandatory:true},{name:'Container type',mapTo:'',mandatory:false},{name:'Case size',mapTo:'',mandatory:true},
                     {name:'Case weight',mapTo:'',mandatory:false},{name:'Pallet TI',mapTo:'',mandatory:false},
                     {name:'Pallet HI',mapTo:'',mandatory:false},{name:'UPC',mapTo:'',mandatory:false},
                     {name:'SCC',mapTo:'',mandatory:false},{name:'In-bond price',mapTo:'',mandatory:false},
                     {name:'Duty-paid price',mapTo:'',mandatory:false},
                     {name:'Initial in-bond cases',mapTo:'',mandatory:false},{name:'Initial in-bond value',mapTo:'',mandatory:false},
                     {name:'Initial duty-paid bottles',mapTo:'',mandatory:false},{name:'Initial duty-paid value',mapTo:'',mandatory:false},
                     {name:'Initial lot',mapTo:'',mandatory:false},{name:'Initial date',mapTo:'',mandatory:false,date:true},
                     {name:'Category',mapTo:'',mandatory:false}
                     ],
      instructions: `<ol class="mb-4">
                        <li>Name</li>
                        <li>SKU (optional)</li>
                        <li>Spirit name</li>
                        <li>Strength</li>
                        <li>Bottle size</li>
                        <li>Container type</li>
                        <li>Case size</li>
                        <li>Case weight (optional, default is 0)</li>
                        <li>Pallet TI (optional, default is 12)</li>
                        <li>Pallet HI  (optional, default is 4)</li>
                        <li>UPC (optional)</li>
                        <li>SCC (optional)</li>
                        <li>In-bond price (optional, default is 0)</li>
                        <li>Duty-paid price (optional, default is 0)</li>
                        <li>Initial in-bond cases (optional, default is 0)</li>
                        <li>Total initial in-bond value (optional, default is 0)</li>
                        <li>Initial duty-paid bottles (optional, default is 0)</li>
                        <li>Total initial duty-paid value (optional, default is 0)</li>
                        <li>Initial lot (optional, default is L0)</li>
                        <li>Initial date (optional, default is today)</li>
                        <li>Category (optional)</li>
                      </ol>
                      <em>Note that not all information for a product can be imported.</em>
                      For example, the bill of materials for a product is not imported.
                      You should, therefore, check each imported product to ensure all settings are correct.`
    }
  },
  watch: {
    value() {
      this.showImport = this.value;
    },
    showImport() {
      this.$emit('input', this.showImport);
    }
  },
  methods: {
    doImport() {
      this.$refs.import.doImport();
    },
  }
}
</script>
